import { render, staticRenderFns } from "./PatientComplaintsWoman.vue?vue&type=template&id=0e307c82&scoped=true"
import script from "./PatientComplaintsWoman.vue?vue&type=script&lang=js"
export * from "./PatientComplaintsWoman.vue?vue&type=script&lang=js"
import style0 from "./PatientComplaintsWoman.vue?vue&type=style&index=0&id=0e307c82&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0e307c82",
  null
  
)

export default component.exports